import { render, staticRenderFns } from "./stateRoom.vue?vue&type=template&id=3a4d84f7&scoped=true"
import script from "./stateRoom.vue?vue&type=script&lang=js"
export * from "./stateRoom.vue?vue&type=script&lang=js"
import style0 from "./stateRoom.vue?vue&type=style&index=0&id=3a4d84f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4d84f7",
  null
  
)

export default component.exports